
export const EditingMixin = {
  created () {
    if (this.$route.params.editing_object) {

      this.custom = this.$route.params.courseApplicationType === 'General' ? 0 : 1

      

      this.checkingEdit = 'Update'

      this.editingtrue = true
      this.currentTab = this.$route.params.editing_type
      
      
      const editing_object = this.$route.params.editing_object

      
      
      this.courseClicked(this.$route.params.editing_type)

      //   

      const subject_id = editing_object.subjects.map(ele => {
        return ele.subject_id
      })

      this.subject_ids = []

      if (this.currentTab === 'Lessons') {
        this.editingLessonArray(editing_object, subject_id)
      } else if (this.currentTab === 'course') {
        
        
        this.editingCourse(editing_object, subject_id)
      } else if (this.currentTab === 'Topics') {
        this.editingTopic(editing_object, subject_id)
      }
    

    }
  },
  methods:{
    // file_ids: [1523, 1522]

    editingCourse (editing_object) {
      
      this.course_id = editing_object.id
      this.course_header.name = editing_object.name
      this.course_header.description = editing_object.description
      this.course_header.course_image = editing_object.courseImage ? editing_object.courseImage.file_id : null
      this.course_header.course_image_info = editing_object.courseImage ? editing_object.courseImage : null

      this.assets = editing_object.assets ? editing_object.assets : []

      
      this.file_ids = editing_object.courseFiles.map(ele => {
        
        return ele.file_id
      })
      // this.file_ids = []
      this.content = editing_object.courseContent
      this.subject_ids = editing_object.subjects.map(ele => {
        return ele.subject_id
      })
      
      this.filesInfo = editing_object.courseFiles
      this.imported_question_details = editing_object.courseQuestions
      this.imported_assignment_details = editing_object.courseAssignments

      // this.imported_assignment_details_added_info = editing_object.courseAssignments
      // this.imported_question_details_added_info = editing_object.courseQuestions
      this.question_ids = this.getQuestionIds(editing_object.courseQuestions)
      this.assignment_ids = this.getAssignmentIds(editing_object.courseAssignments)

      this.showCourseContent = true
      this.showFileContent = false
      //for getting lesson array
      this.lessons_array = editing_object.courseLessons.map(ele => {
        
        
        return {
          id:ele.lesson.id,
          name: ele.lesson.name,
          description: ele.lesson.description,
          subject_ids: [],
          file_ids: this.getFileIds(ele.lesson.lesson_files),
          question_ids: this.getQuestionIds(ele.lesson.lesson_questions),
          assignment_ids:this.getAssignmentIds(ele.lesson.lesson_assignments),
          imported_question_details : ele.lesson.lesson_questions,
          imported_assignment_details : ele.lesson.lesson_assignments,
          // imported_assignment_details_added_info:ele.lesson.lesson_assignments,
          // imported_question_details_added_info:ele.lesson.lesson_questions,
          content:ele.lesson.lesson_content ? ele.lesson.lesson_content : '',

          showCourseContent: true,
          showFileContent: false,
          isCollapseCard:false,
          filesInfo:ele.lesson.lesson_files,
      
          topics:ele.lesson.lesson_topics.map(element => {
            return {
              id:element.topic.id,
              name:element.topic.name,
              description: element.topic.description,
              subject_ids:[],
              assignment_ids:[],
              question_ids: [],
              content:{
                id:element.topic.topic_content.id ? element.topic.topic_content.id : null,
                content:element.topic.topic_content.content ? element.topic.topic_content.content : ''
              },
              file_ids: this.getFileIds(element.topic.topic_files),
              showCourseContent:false,
              showFileContent:false,
              isCollapseCard:false,
              filesInfo:element.topic.topic_files
             
            }

          })
          

        }

      })
    //   assignment_ids: ele.lesson.assignments,
    //   question_ids: ele.lesson.questions,

      //for getting lesson array
    
    
    },
    editingLessonArray (editing_object) {
      // this.subjects_added = editing_object.subjects
      this.subject_ids = editing_object.subjects.map(ele => {
        return ele.subject_id
      })
      // 
      this.lessons_array.push({
        id:editing_object.id,
        name: editing_object.name,
        description: editing_object.description,
        subject_ids: [],
        assignment_ids: this.getAssignmentIds(editing_object.lessonAssignments),
        question_ids: this.getQuestionIds(editing_object.lessonQuestions),
        file_ids: this.getFileIds(editing_object.lessonFiles),
        imported_question_details : editing_object.lessonQuestions,
        imported_assignment_details : editing_object.lessonAssignments,
        // imported_assignment_details_added_info:editing_object.lessonAssignments,
        // imported_question_details_added_info:editing_object.lessonQuestions,
        content:editing_object.lessonContent,
        showCourseContent: true,
        showFileContent: false,
        isCollapseCard:false,
        filesInfo:editing_object.lessonFiles,

        topics:editing_object.lessonTopics.map(ele => {
          
          return {
            id:ele.topic.id,
            name:ele.topic.name,
            description: ele.topic.description,
            subject_ids:[],
            assignment_ids:[],
            question_ids: [],
            content:{
              id:ele.topic.topic_content.id ? ele.topic.topic_content.id : null,
              content:ele.topic.topic_content.content ? ele.topic.topic_content.content : ''
            },
            file_ids: this.getFileIds(ele.topic.topic_files),
            showCourseContent:false,
            showFileContent:false,
            isCollapseCard:false,
            filesInfo:ele.topic.topic_files
          }
        })
      })
      
    },
    editingTopic (editing_object) {
      
      // this.subjects_added = editing_object.subjects
      this.subject_ids = editing_object.subjects.map(ele => {
        return ele.subject_id
      })
      // 
      this.topics_array.push({
        id:editing_object.id,
        name:editing_object.name,
        description: editing_object.description,
        subject_ids:[],
        assignment_ids:[],
        question_ids: [],
        content:{
          id:editing_object.topicContent ? editing_object.topicContent.id : null,
          content:editing_object.topicContent ? editing_object.topicContent.content : ''
        },
        file_ids: this.getFileIds(editing_object.topicFiles),
        showCourseContent:false,
        showFileContent:false,
        isCollapseCard:false,
        filesInfo:editing_object.topicFiles

      })

    },
    get_file_id (file) {
      if (file.length === 0) {
        return []
      } 

      const fileObj = file.map(ele => {
        return ele.file_id
      })

      

      return fileObj


    },
    getTopic (topicArray) {
      if (!topicArray.length) {
        return []
      } else {
        topicArray.map(ele => {
          
          return {
            id:ele.topic.id,
            name:ele.topic.name,
            description: ele.topic.description,
            subject_ids:[],
            assignment_ids:[],
            question_ids: [],
            content:{
              id:ele.topic.topic_content.id ? ele.topic.topic_content.id : null,
              content:ele.topic.topic_content.content ? ele.topic.topic_content.content : ''
            },
            file_ids: [],
            showCourseContent:false,
            showFileContent:false,
            isCollapseCard:false,
            filesInfo:ele.topic.topic_files
          }
        })

      }
    },
    getQuestionIds (questionsObject) {
      if (questionsObject.length == 0) {
        return []
      } else {
        return questionsObject.map(ele => {
          return ele.question_bank_id
        })

      }
    },
    getAssignmentIds (assignmentObject) {
      
      
      if (assignmentObject.length == 0) {
        return []
      } else {
        return assignmentObject.map(ele => {
          return ele.assignment_builder_id
        })

      }
    },
    getFileIds (fileObject) {
      if (fileObject.length == 0) {
        return []
      } else {
        return fileObject.map(ele => {
          return ele.file_id
        })

      }
    }
  }
 
}